import {
  ChevronLeftIcon,
  ChevronRightIcon,
  GitBranch01Icon,
} from '@langchain/untitled-ui-icons';

import { IconButton } from '@/design-system';
import { RunSchema } from '@/types/schema';
import { cn } from '@/utils/tailwind';

import { isRealRun } from '../utils/isRealRun';

export function DatasetSessionCompareRunCellActions({
  run,
  sessionId,
  handleTraceButtonClick,
  showRepetitionsUI,
  runInViewIdx,
  setRunInViewIdx,
  totalRuns,
}: {
  run?: RunSchema;
  sessionId?: string;
  handleTraceButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showRepetitionsUI: boolean;
  runInViewIdx: number;
  setRunInViewIdx: (runInViewIdx: number) => void;
  totalRuns: number;
}) {
  return (
    <div className="flex items-center text-xs">
      {showRepetitionsUI && (
        <>
          <div className="flex flex-row gap-[1px] rounded-md px-1 py-0.5 font-medium tabular-nums">
            <span>{runInViewIdx + 1}</span>
            <span>/</span>
            <span>{totalRuns}</span>
          </div>
          <button
            className={cn(
              'rounded-md p-[1px]',
              runInViewIdx === 0 ? 'opacity-50' : 'hover:bg-quaternary'
            )}
            type="button"
            onClick={() => setRunInViewIdx(Math.max(runInViewIdx - 1, 0))}
            disabled={runInViewIdx === 0}
          >
            <ChevronLeftIcon className="h-4 w-4" />
          </button>
          <button
            className={cn(
              'rounded-md p-[1px]',
              runInViewIdx === totalRuns - 1
                ? 'opacity-50'
                : 'hover:bg-quaternary'
            )}
            type="button"
            onClick={() =>
              setRunInViewIdx(Math.min(runInViewIdx + 1, totalRuns - 1))
            }
            disabled={runInViewIdx === totalRuns - 1}
          >
            <ChevronRightIcon className="h-4 w-4" />
          </button>
        </>
      )}
      {run && sessionId && isRealRun(run) && (
        <IconButton
          type="button"
          color="secondary"
          icon={GitBranch01Icon}
          label="Expand trace"
          size="sm"
          variant="outlined"
          onClick={handleTraceButtonClick}
          data-testid="dataset-session-compare-run-cell-actions-trace-button"
        />
      )}
    </div>
  );
}
